<template>
  <div class="budget-v2">
    <Chart :title="title" :currency="settings.currency">
      <template #chart>
        <HighChart v-if="chartData" :options="mergedChartData" />
      </template>
      <template #widget-options>
        <div class="actions-wrapper">
          <YearSelect v-model="financialPeriodId" />
          <slot name="widget-options" />
        </div>
      </template>
    </Chart>
  </div>
</template>

<script>
import * as apiTo from '../../../api'
import { customChartData } from './custom-chart-data'
// Libraries
import { merge } from 'lodash'
// Components
import { Chart as HighChart } from 'highcharts-vue'
import Chart from '../Chart'
import YearSelect from '@/modules/financial/shared/YearSelect'

export default {
  components: {
    Chart,
    HighChart,
    YearSelect
  },

  props: {
    title: String
  },

  data: () => ({
    chartData: null,
    financialPeriodId: null
  }),

  computed: {
    mergedChartData() {
      if (!this.chartData) return
      return merge(this.chartData.chart, this.customChartData)
    }
  },

  watch: {
    financialPeriodId: 'getChartData'
  },

  created() {
    this.customChartData = customChartData()
    this.selectedYear = new Date().getFullYear()
  },

  methods: {
    getChartData(periodId) {
      apiTo
        .getChartDataForFinancialPeriod(periodId, 'budget-vs-actual-per-department-version-2')
        .then(({ data }) => (this.chartData = data.result))
    }
  }
}
</script>

<style lang="stylus" scoped>
.actions-wrapper {
  display flex
  align-items center
  justify-content flex-end
}
</style>
